const { microservices } = require('./microservices');

const config = {
  name: 'cp-utils',

  globals: {
    microservices: microservices,
  },
};

module.exports.config = config;
